<mat-form-field class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">
  <mat-label>Preview *</mat-label>
  <input matInput placeholder="Input" style="display: none"
         particleAnalytics
         analyticsCategory="choice-filter-modal-item-editor"
         analyticsAction="entity-scope-input">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node class="single-item" *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding
                   [ngClass]="{'level0': node.level===0, 'level1': node.level===1, 'level2': node.level===2, 'level3': node.level===3, 'level4': node.level===4,
                    'level5': node.level===5}">
      <button (click)="onCLick(node)" class="checklist-leaf-node flex flex-row justify-start items-center">
        <i *ngIf="node.icon" [ngClass]="node.icon"></i>
        <span>{{node.title}}</span>
      </button>

      <button mat-icon-button *ngIf="isAdmin && node.type==='ExternalLink' && node.level!==0"
              (click)="onExternalLinkDelete(node)">
        <mat-icon>delete</mat-icon>
      </button>
    </mat-tree-node>

    <mat-tree-node class="child-item" [ngClass]="{'level0': node.level===0, 'level1': node.level===1, 'level2': node.level===2, 'level3': node.level===3,
    'level4': node.level===4, 'level5': node.level===5}" matTreeNodePadding *matTreeNodeDef="let node; when: hasChild">
      <button class="checklist-leaf-node flex flex-row justify-start items-center" matTreeNodeToggle
              [attr.aria-label]="'Toggle ' + node.title">

        <i *ngIf="node.icon" [ngClass]="node.icon"></i>
        <span>{{node.title}}</span>
        <mat-icon class="mat-icon-rtl-mirror">
          {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
        </mat-icon>
      </button>
    </mat-tree-node>
  </mat-tree>
</mat-form-field>

<div class="flex flex-row justify-start items-center">
  <button mat-button class="light-background-button m-r-20" (click)="addOrbitaxSolution()">Add Orbitax Solution</button>

  <button mat-button class="light-background-button" (click)="addExternalLink()">Add External Link</button>
</div>

